module.exports = __webpack_public_path__ + "static/media/separator-pink.357feba7.svg";